import { usePageTitle } from "@/hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { UsersActions } from "@/resources-def/users-comp";
import { RESOURCE_TYPE_USERS } from "@/resources-def/users";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { CheckCircleOutlined } from "@ant-design/icons";
import { RESOURCE_TYPE_INSTANCES } from "@/resources-def";
import { useList } from "@refinedev/core";

const RESOURCE = RESOURCE_TYPE_USERS;

export const UsersListPage = ({ children }) => {
  usePageTitle("Users");
  const { t } = useTranslation();
  const navigate = useResourceNavigate();

  const {data: instances, isLoading} = useList({
    resource: RESOURCE_TYPE_INSTANCES,
  })

  const enrichIds = (instanceIds) => {
    if(instances?.data && instanceIds) {
      return instanceIds.map((id) => {
        const instance = instances.data.find((instance) => instance.id === id);
        if(instance) {
          return {name : instance.name, id: id}
        } else 
          return {id: id}
      })
    } else 
      return [];
  }

  const columns = [
    {
      title: t("fields.name"),
      dataIndex: "name",
      render: (text, record) => (
        <a onClick={(e) => navigate({ resource: RESOURCE, key: record.name, action: "show" })}>{text}</a>
      ),
    },
    { title: t("users.fields.email"), dataIndex: "email" },
    { title: t("users.fields.fullname"), dataIndex: "fullname" },
    { title: t("users.fields.instances"), dataIndex: "instances",
      render: (text, record) => {
        const tagList = enrichIds(text);
        return (
          <div>
            {tagList.map((tag, index) => (
              tag.name ? <span key={index} style={{ marginRight: 8, display: 'inline-block' }}>
                {tag.name}
              </span> : <span key={index} style= {{color: "red"}}>
                {tag.id}
              </span>
            ))}
          </div>
        );
      }
     },
    {
      title: t("users.fields.isAdmin"),
      dataIndex: "isAdmin",
      render: (value) => value === true && <CheckCircleOutlined />,
    },
    {
      title: t("users.fields.storage"),
      dataIndex: "storage",
      render: (value) => value == "cognito" && <CheckCircleOutlined />,
    },
    { title: t("users.fields.status"), dataIndex: "status" },
    { title: t("users.fields.createdAt"), dataIndex: "createdAt" },
  ];

  return <ResourceListLayout keyField="name" resource={RESOURCE} actions={UsersActions} columns={columns} />;
};
